import React from "react";
import "./FlagOption.css";

const FlagOption = ({
  country,
  onClick,
  showFeedback,
  isCorrect,
  isCorrectAnswer,
}) => {
  const getButtonClass = () => {
    if (!showFeedback) return "flag-option";

    let classes = "flag-option";
    if (isCorrect !== undefined) {
      classes += isCorrect ? " correct" : " incorrect";
    } else if (isCorrectAnswer) {
      classes += " correct show-correct";
    }
    return classes;
  };

  return (
    <button
      className={getButtonClass()}
      onClick={onClick}
      disabled={showFeedback}
    >
      {country.name}
    </button>
  );
};

export default FlagOption;
